import { Card, Text } from "@merge-api/merge-javascript-shared";
import StepIOLogModalSectionRow from "./StepIOLogModalSectionRow";

interface Props {
  title: string;
  data: { [key: string]: any } | null;
  copyableDataKeys?: string[];
}

const StepIOLogModalSection = ({ title, data, copyableDataKeys }: Props) => {
  const dataArray = data ? Object.entries(data) : [];

  return (
    <Card className="bg-gray-0" variant="none">
      <div className="flex flex-col p-3">
        <Text variant="h6">{title}</Text>
        {dataArray.length === 0 ? (
          <Text variant="md-mono" className="pt-2 text-gray-40 border-t border-gray-10">
            No data
          </Text>
        ) : (
          dataArray.map(([dataKey, value]) => (
            <StepIOLogModalSectionRow
              key={dataKey}
              dataKey={dataKey}
              dataValue={value}
              isCopyable={copyableDataKeys?.includes(dataKey)}
            />
          ))
        )}
      </div>
    </Card>
  );
};

export default StepIOLogModalSection;
